export default function * failure ({error}) {
  // console.log('Verify Okta Account failure -----------', JSON.stringify(error));
}
